import type React from 'react';
import { makeStyles, tokens, Button } from '@fluentui/react-components';
import { ShieldErrorRegular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    height: '100dvh',
    backgroundColor: tokens.colorNeutralBackground1,
    gap: tokens.spacingVerticalL,
    padding: tokens.spacingHorizontalXXL,
    '@media (max-width: 768px)': {
      padding: tokens.spacingHorizontalL,
    },
  },
  icon: {
    fontSize: '64px',
    color: tokens.colorPaletteRedForeground1,
    '@media (max-width: 768px)': {
      fontSize: '48px',
    },
  },
  title: {
    fontSize: tokens.fontSizeHero700,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    margin: 0,
    textAlign: 'center',
    '@media (max-width: 768px)': {
      fontSize: tokens.fontSizeBase500,
    },
  },
  message: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    textAlign: 'center',
    maxWidth: '400px',
  },
});

/**
 * Page shown when user doesn't have permission to access a resource.
 */
export const UnauthorizedPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <ShieldErrorRegular className={styles.icon} />
      <h1 className={styles.title}>{t('unauthorized.title', 'Access Denied')}</h1>
      <p className={styles.message}>
        {t(
          'unauthorized.message',
          "You don't have permission to access this page. Please contact your administrator if you believe this is an error.",
        )}
      </p>
      <Button appearance="primary" onClick={() => navigate('/')}>
        {t('unauthorized.goHome', 'Go to Home')}
      </Button>
    </div>
  );
};
